import {GraphQLValidationError} from 'app/core/error-handler/errors/grahpql/validation-error';

export class GraphQLDemoAccountRequestError extends GraphQLValidationError {
    constructor(message) {
        super(message, <any>{graphQLErrors: []});
    }

    isCritical() {
        return false;
    }

    get userMessage() {
        return this.transform('errors.DemoUserNotAllowedSendMutation') || this.message;
    }

    fingerPrint() {
        return ['GrapqlDemoAccountRequestError'];
    }
}
